var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
    ((!!_vm.$route.query.header_type &&
      _vm.$route.query.header_type !== _vm.HeaderType.HideHeader &&
      ((_vm.$route.meta.common && !_vm.$route.meta.home) ||
        (_vm.$route.meta.common && _vm.$route.meta.home && _vm.$route.query.header_type === _vm.HeaderType.Header))) ||
      _vm.$route.name === 'rankList') &&
    _vm.encludePage
  )?_c('back',{attrs:{"darkbg1":_vm.darkbg}}):_vm._e(),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":"ring-zone,ringtone-topic,search-page,recommond-list,tab-home,topic-list-details,miguBJYH,miguBJYH-ringzone"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }